import { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { ChevronLeft, KeyRound, Search } from 'lucide-react'
import { useT } from '@/i18n'
import { PageHeader } from '@/shell/AppShell'
import { catalogEntries } from './catalogEntries'

const CAP = 400

/**
 * A22.03 — Kalitlar ro'yxati. Manba: klient i18n kataloglari (uz/ru/en, `CATALOGS`).
 * Har kalit + 3 til qiymati; qidiruv bilan filtrlanadi. Backend YO'Q (client-side).
 */
export function LocalizationKeys() {
  const t = useT()
  const [q, setQ] = useState('')
  const all = useMemo(() => catalogEntries(), [])
  const filtered = useMemo(() => {
    const s = q.trim().toLowerCase()
    if (!s) return all
    return all.filter(
      (e) =>
        e.key.toLowerCase().includes(s) ||
        e.en.toLowerCase().includes(s) ||
        e.ru.toLowerCase().includes(s) ||
        e.uz.toLowerCase().includes(s),
    )
  }, [all, q])
  const shown = filtered.slice(0, CAP)

  return (
    <>
      <PageHeader
        title={t.loc.keysTitle}
        screenId="A22.03"
        actions={
          <Link
            to="/localization"
            className="inline-flex items-center gap-1 rounded-md border border-border-default bg-surface-2 px-2.5 py-1 text-sm text-secondary hover:text-primary"
          >
            <ChevronLeft size={13} />
            {t.loc.title}
          </Link>
        }
      />
      <div className="border-b border-border-subtle p-3">
        <div className="flex items-center gap-2 rounded-md border border-border-default bg-surface-2 px-2.5 py-1.5">
          <Search size={14} className="text-tertiary" />
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder={t.loc.searchPh}
            className="w-full bg-transparent text-sm text-primary outline-none placeholder:text-tertiary"
          />
          <span className="whitespace-nowrap text-xs text-tertiary">
            {filtered.length.toLocaleString()} / {all.length.toLocaleString()}
          </span>
        </div>
      </div>
      <div className="min-h-0 flex-1 overflow-auto p-3">
        <div className="overflow-hidden rounded-md border border-border-default">
          <div className="grid grid-cols-[minmax(140px,1fr)_1fr_1fr_1fr] gap-3 border-b border-border-default bg-surface-2 px-3 py-2 text-xs font-medium text-tertiary">
            <span>{t.loc.keys}</span>
            <span>EN</span>
            <span>RU</span>
            <span>UZ</span>
          </div>
          {shown.length === 0 ? (
            <div className="px-3 py-6 text-center text-sm text-tertiary">
              <KeyRound size={22} className="mx-auto mb-2 opacity-60" />
              {t.states.emptyTitle}
            </div>
          ) : (
            shown.map((e) => (
              <div
                key={e.key}
                className="grid grid-cols-[minmax(140px,1fr)_1fr_1fr_1fr] gap-3 border-b border-border-subtle px-3 py-1.5 text-sm last:border-0"
              >
                <span className="truncate font-mono text-xs text-accent" title={e.key}>
                  {e.key}
                </span>
                <span className="truncate text-secondary" title={e.en}>{e.en}</span>
                <span className="truncate text-secondary" title={e.ru}>{e.ru}</span>
                <span className="truncate text-secondary" title={e.uz}>{e.uz}</span>
              </div>
            ))
          )}
        </div>
        {filtered.length > CAP && (
          <p className="mt-2 text-center text-xs text-tertiary">
            {t.loc.showingCap(CAP, filtered.length)}
          </p>
        )}
      </div>
    </>
  )
}
